import { render, staticRenderFns } from "./ColumnName.vue?vue&type=template&id=42db2f58&scoped=true&"
import script from "./ColumnName.vue?vue&type=script&lang=js&"
export * from "./ColumnName.vue?vue&type=script&lang=js&"
import style0 from "./ColumnName.vue?vue&type=style&index=0&id=42db2f58&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42db2f58",
  null
  
)

export default component.exports